export default "__VITE_PUBLIC_ASSET__d20f0b93__"